import type { ReactNode } from 'react'
import { LocalStorageContext } from './local-storage-ctx'

export function LocalStorageProvider({
  storage,
  children,
}: {
  storage: Storage
  children: ReactNode
}) {
  return (
    <LocalStorageContext.Provider value={storage}>
      {children}
    </LocalStorageContext.Provider>
  )
}
